<template>
  <app-main />
  <template v-if="active">
    <app-dialog :active="active">
      <app-start></app-start>
    </app-dialog>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Main from "./views/Main.vue";
import Start from "./views/Start.vue";

export default defineComponent({
  name: "App",
  components: {
    "app-main": Main,
    "app-dialog": () => import("./components/Dialog.vue"),
    "app-start": Start
  },
  setup() {
    // Работа с диалоговым окном
    const active = ref(false);

    return {
      active
    };
  }
});
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
}

body {
  padding: 0;
  margin: 0;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
